import { Link, Typography } from "@mui/material";
import { Styled } from "./styles";
import { Mail } from "@dippi/icons";
import GetStarted from "./get-started";
import Basic from "./basic";
import Mandatory from "./mandatory";
import Label from "./label";
import Nutritions from "./nutritions";
import Ingredients from "./ingredients";
import Browser from "./browser";
import QR from "./qr-code";
import Accounts from "./accounts";
import Switch from "./switch";
import Producer from "./producer";
import Limitations from "./limitations";

const Support: React.FC = () => {
    return (
        <Styled.Container>
            <Styled.Content>
                <Styled.Contact>
                    <Typography>
                        Send us email if you have any questions:
                        <Link
                            href="mailto:info@dippi.app"
                            underline="none"
                            color="#ffffff"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <Mail />
                            info@dippi.app
                        </Link>
                    </Typography>
                </Styled.Contact>
                <Styled.Accordion>
                    <Typography className="title">F.A.Q.</Typography>
                    <GetStarted />
                    <Basic />
                    <Mandatory />
                    <Label />
                    <Nutritions />
                    <Ingredients />
                    <Browser />
                    <QR />
                    <Accounts />
                    <Switch />
                    <Producer />
                    <Limitations />
                </Styled.Accordion>
            </Styled.Content>
        </Styled.Container>
    );
};

export default Support;
